
    import {Component, Vue, Watch} from 'vue-property-decorator';
    import {qiChaChaApi, mechanismApi, dictApi} from "@/api/organization";
    import baseUrl, {imageUrl} from "../../constants";
    const {regionData} =require("@/js/region/region");
    import CoordPicker from "@/components/CoordPicker.vue";

    @Component({
        components: {CoordPicker}
    })
    export default class Home extends Vue {
        screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
        notCompany = false;  //找不到单位信息
        regionData = regionData
        baseUrl = baseUrl
        imageUrl = imageUrl
        headers = {Authorization: ""}
        mechanismData = {
            types: [] as any, //单位类别数组
            type: '', //单位类别
            level: '', //级别
            code: '', //统一社会信用代码
            loginName: '',//登陆用户名
            name: '', //机构名称
            regions: [], //所在区域数组
            region: '', //所在区域
            residence: '', //单位注册地址
            userName: '', //法人代表/负责人
            location: '', //经纬度坐标
            postalAddress: '', //通讯地址
            executiveDirector: '', //主管单位名字
            license: '',//执照
            corporate: '', //法人证书
            vcode: '',//验证码
            token: '', //短信验证码签名串
            idCard: '', //被委托人身份证号码
            clientName: '', //被委托人姓名
            avatar: '',//单位管理员头像
            idCardUp: '',//被委托人身份证头像面复印件
            idCardDown: '',//被委托人身份证国徽面复印件
            //用户名
            landline: '',//联系人座机电话
            templatePowerAttorney: '',//授权证书模板
            empower: '',//授权委托书
            userMobile: '', //联系人手机号码
            originalName:[], //公司曾用名
        }
        active = 0
        levels = []
        isSend = true //发送验证码
        smsInterval = "点击获取验证码"
        mechanismTypeList = []
        map = {
            visible: false,
        }
        btnDisable = false;

        // 验证身份证
        checkIdCard = (rule: any, value: any, cb: any) => {
            // let _IDRe18 = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
            // let _IDre15 =  /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/
            if(value.length == 18) {
                cb();
            } else {
                cb(new Error('清输入合法的身份证号码!'))
            }
        }
        // 验证 信用代码
        checkCode = (rule: any, value: any, cb: any) => {
            const flag = this.isAuthMechanism();
            if(value.length != 0) {
                if(flag){
                    mechanismApi.checkLoginUserName({code: value}).then((r) => {
                        if (r.data.result === 0) {
                            cb();
                        } else {
                            cb(new Error(r.data.message))
                        }
                    });
                }else{
                    cb();
                }
            } else {
                if(flag){
                    cb(new Error('请输入统一信用代码/授权证书号!'));
                }else{
                    cb(new Error('请输入统一社会信用代码!'));
                }
            }
        }
        // 验证授权证书
        checkCorporate = (rule: any, value: any, cb: any) => {
            if(value.length != 0) {
                cb();
            } else {
                if(this.isAuthMechanism()){
                    cb(new Error('请上传授权证书!'));
                }else{
                    cb(new Error('请上传法人证书/营业执照!'));
                }
            }
        }

      checkName = (rule: any, value: any, cb: any) => {
          debugger;
        if (value.length > 0) {
          if(value.includes('*')){
            cb(new Error('请您使用营业执照上的经营者名称注册，单位名称至少4个字符，例如：个体工商户张力'));
            return;
          }
          cb();
        } else {
          cb(new Error('请输入单位名称'))
        }
      }


        // 验证名称是否重复
        checkLoginUserName = (rule: any, value: any, cb: any) => {
            if(this.isAuthMechanism()){
                mechanismApi.checkLoginUserName({loginName: value}).then((r) => {
                    if (r.data.result === 0) {
                        cb();
                    } else {
                        cb(new Error(r.data.message))
                    }
                });
            }else{
                cb();
            }
        }

        rules = {
            types: [{required: true, message: "请选择单位类别", trigger: "blur"}],
            level: [{required: true, message: "请选择单位级别", trigger: "blur"}],
            code:  [{validator: this.checkCode,trigger:'blur'}], //[{required: true, message:  ? '请输入统一社会信用代码' : '请输入授权证书号' , trigger: "blur"}],
            loginName: [{required: true, message: "请输入登陆用户名", trigger: "blur"}, {validator: this.checkLoginUserName,trigger:'blur'}],
            name: [{required: true, validator: this.checkName, trigger: "blur"}],
            regions: [{required: true, message: "请选择所在区域", trigger: "blur"}],
            residence: [{required: true, message: "请输入单位注册地址", trigger: "blur"}],
            userName: [{required: true, message: "请输入法人代表/负责人", trigger: "blur"}],
            location: [{required: true, message: "请选择地理信息,经纬度坐标", trigger: "blur"}],
            postalAddress: [{required: true, message: "请输入通讯地址", trigger: "blur"}],
            license: [{required: true, message: "请输入主管单位", trigger: "blur"}],
            executiveDirector: [{required: true, message: "请上传主管单位营业执照", trigger: "blur"}],
            corporate: [{validator: this.checkCorporate,trigger:'blur'}], //{required: true, message: "请上传法人证书", trigger: "blur"}],
            vcode: [{required: true, message: "请输入短信验证码", trigger: "blur"}],
            clientName: [{required: true, message: "请输入被委托人姓名", trigger: "blur"}],
            avatar: [{required: true, message: "请上传单位管理员头像", trigger: "blur"}],
            idCardDown: [{required: true, message: "请上传被委托人身份证国徽面复印件", trigger: "blur"}],
            idCardUp: [{required: true, message: "请上传被委托人身份证头像面复印件", trigger: "blur"}],
            // landline: [{required: true, message: "请输入联系人座机电话", trigger: "blur"}],
            empower: [{required: true, message: "请上传授权委托书", trigger: "blur"}],
            landline: [{required: true, message: "请输入单位联系电话", trigger: "blur"}],
            userMobile: [{required: true, message: "请输入联系人手机号", trigger: "blur"}],
            idCard: [{required: true, message: "请输入被委托人身份证号码", trigger: "blur"}, {validator: this.checkIdCard,trigger:'blur'}]
        }

        created() {
          if(this.$route.query.types){
            const types =  this.$route.query.types as string;
            this.mechanismData.types = types.split(',');
          }
            this.listDict();
        }
        //上一个
        prevStep() {
            this.active--;
        }

        //下一个
        nextStep() {
            let form = this.$refs.form as HTMLFormElement;
            debugger;
            form.validate((valid: any) => {
                if (valid) {
                    if(this.active === 0){
                        if(this.mechanismData.empower == ""){
                            this.$message.warning("请上传授权委托书");
                            return;
                        }
                        this.active++;
                    }else if(this.active === 2){
                        { // 5秒内禁止再次点击
                            if(this.btnDisable){
                                this.$message.warning("点击过于频繁，请稍后再试！")
                                return;
                            }
                            this.btnDisable = true;
                            setTimeout(() => {
                                this.btnDisable = false;
                            }, 5000);
                        }
                        mechanismApi.checkVerifyUI({
                            token: this.mechanismData.token,
                            vcode: this.mechanismData.vcode
                        }).then((r) => {
                            if (r.data.result === 0) {
                                this.regist();
                            }
                        });
                    }else {
                        this.active++;
                    }
                }else{
                    this.$message.warning("未填写完整信息");
                }
            });
        }

        //是否是授权机构
        isAuthMechanism(){
            return this.mechanismData.types.indexOf("0006") > -1 || this.mechanismData.types.indexOf("0008") > -1;
        }
        // 打开地图
        showMap() {
            this.map.visible = true;

        }

      isDisable(val: string) {
        if(val === "0001"){
          return true;
        }else if(val === "0006"){
          return true;
        }
        return false;
      }


      listDict() {
            //单位级别
            dictApi.listDictItem({typeCode: "dwjb"}).then((r) => {
                if (r.data.result === 0) {
                    this.levels = r.data.data;
                }
            });

            //单位类别
            dictApi.listDictItem({typeCode: "dwlb"}).then((r) => {
                if (r.data.result === 0) {
                    this.mechanismTypeList = r.data.data;
                }
            });
        }

        handleUpdateChange(value: any) {
            this.mechanismData.region = value.join(",").replace(/\s+/g, "");
        }

        //查单位
        selectByOrgCodeOne() {
            this.notCompany = false;
            this.mechanismData.loginName = this.mechanismData.code;
            qiChaChaApi.selectByCode({creditCode: this.mechanismData.code}).then((r) => {
                if (r.data.result === 0) {
                    const org = r.data.data;
                    this.$confirm(`已检索到相关单位信息 , 单位名称：${org.name} , 法人：${org.operName}。是否确认匹配？`, '确认信息', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                        showClose: false,
                        closeOnClickModal: false,
                        closeOnPressEscape: false,
                    }).then(() => {
                        this.mechanismData.name = org.name;
                        this.mechanismData.residence = org.address;
                        this.mechanismData.userName = org.operName;
                        // this.mechanismData.originalName = org.originalName;
                    }).catch(() => {
                        this.mechanismData.code = "";
                        this.mechanismData.loginName = "";
                    });
                }else if(r.data.result === 1){
                    this.$message.warning("查询无结果,可以【手动填写】或修改【统一社会信用代码】");
                    this.notCompany = true;
                }
            });
        }
        //注册
        regist() {
            let form = this.$refs.form as HTMLFormElement;
            form.validate((valid: any) => {
                if (valid) {
                    const mechanismData = this.mechanismData;
                    mechanismData.level = (mechanismData.types.indexOf('0001') > -1 || mechanismData.types.indexOf('0002') > -1) ? mechanismData.level : ''
                    mechanismData.type = "," + mechanismData.types.join(",") + ",";
                    const data = {
                        mechanism: {
                            code: mechanismData.code,
                            //单位类别
                            type: mechanismData.type,
                            //单位级别
                            level: mechanismData.level,
                            //单位名称
                            name: mechanismData.name,
                            //单位所属区域
                            region: mechanismData.region,
                            //单位注册地址
                            residence: mechanismData.residence,
                            //法人代表/负责人
                            userName: mechanismData.userName,
                            //手机号
                            userMobile: mechanismData.userMobile,
                            //单位地理位置
                            location: mechanismData.location,
                            //单位通讯地址
                            postalAddress: mechanismData.postalAddress,
                            //法人证书
                            corporate: mechanismData.corporate,
                            //授权证书
                            empower: mechanismData.empower,
                            //主管单位名字
                            executiveDirector: mechanismData.executiveDirector,
                            //执照
                            license: mechanismData.license,
                            //单位曾用名
                            originalName: mechanismData.originalName,
                            //被委托人身份证头像面复印件
                            cardUp: mechanismData.idCardUp,
                            //被委托人身份证国徽面复印件
                            cardDown: mechanismData.idCardDown,
                            //联系人座机号
                            landline: mechanismData.landline,
                        },
                        user: {
                            //被委托人身份证号码
                            idCard: mechanismData.idCard,
                            //被委托人姓名
                            name: mechanismData.clientName,
                            //单位管理员头像
                            avatar: mechanismData.avatar,
                            //被委托人身份证头像面复印件
                            idCardUp: mechanismData.idCardUp,
                            //被委托人身份证国徽面复印件
                            idCardDown: mechanismData.idCardDown,
                            ////联系人手机号码
                            phone: mechanismData.userMobile,
                        },
                        userLogin: {
                            //用户名
                            name: mechanismData.loginName,
                            //联系人座机电话
                            landline: mechanismData.landline,
                            //单位管理员头像
                            avatar: mechanismData.avatar,
                        },
                        //手机短信验证码
                        vcode: mechanismData.vcode,
                        //签名
                        token: mechanismData.token,
                    };

                    mechanismApi.add(data).then((r) => {
                        if (r.data.result === 0) {
                            this.active++;

                            //保存完计时两秒返回登录页
                            setTimeout(() => {
                                this.logout();
                            }, 2000);

                        }
                    });
                }
            })
        }

        checkMobile() {
            //验证手机号
            if (!this.isSend) return;
            const mobile = this.mechanismData.userMobile;
            if (!mobile.match(/^1[3-9][0-9]{9}$/)) {
                this.$message({
                    message: '手机号有误',
                    type: 'warning',
                    duration: 1000,
                    onClose: () => {
                        this.mechanismData.userMobile = '';
                    }
                });
                return false;
            }
            this.isSend = true
            this.sendSms();
        }

        //发送手机验证码
        sendSms() {
            if (!this.isSend) return;
            this.isSend = false;
            this.smsInterval = "发送中...";
            mechanismApi.sendVerifyCodeUnVerify({phone: '+86' + this.mechanismData.userMobile, template: 'register-company'}).then((r) => {
                if (r.data.result === 0) {
                    this.mechanismData.token = r.data.data
                    this.smsIntervalMethod();
                }else{
                  this.smsInterval = "获取验证码";
                  this.isSend = true;
                }
            });
        }

        smsIntervalMethod() {
            let smsIntervalTime = 60;
            let timer = setInterval(() => {
                if (smsIntervalTime <= 1) {
                    clearInterval(timer);
                    this.smsInterval = "获取验证码";
                    this.isSend = true; // 重新回复点击发送功能的条件
                } else {
                    smsIntervalTime -= 1;
                    this.smsInterval = `${smsIntervalTime}秒后再发`;
                }
            }, 1000);
        }
        //主管单位营业执照
        handleExecutiveDirectorSuccess(res: any, fileny: any){
            if (res.result === 0) {
                const rData = res.data;
                this.mechanismData.executiveDirector = rData;
                this.$message.success("上传成功");
            }
        }
        //法人证书上传
        handleCorporateSuccess(res: any, fileny: any) {
            if (res.result === 0) {
                const rData = res.data;
                this.mechanismData.corporate = rData;
                this.$message.success("上传成功");
            }
        }

        // 身份证头像面上传
        handleIdCardUpSuccess(res: any, fileny: any) {
            if (res.result === 0) {
                const rData = res.data;
                this.mechanismData.idCardUp = rData;
                this.$message.success("上传成功");
            }
        }

        //身份证反面上传
        handleIdCardDownSuccess(res: any, fileny: any) {
            if (res.result === 0) {
                const rData = res.data;
                this.mechanismData.idCardDown = rData;
                this.$message.success("上传成功");
            }
        }

        //头像上传
        handleAvatarSuccess(res: any, fileny: any) {
            if (res.result === 0) {
                const rData = res.data;
                this.mechanismData.avatar = rData;
                this.$message.success("上传成功");
            }
        }

        //授权委托书上传
        handleEmpowerSuccess(res: any, fileny: any) {
            if (res.result === 0) {
                const rData = res.data;
                this.mechanismData.empower = rData;
                this.$message.success("上传成功");
            }
        }

        //图片上传判断
        beforeImageUpload(file: any) {
            const isJPG = file.type === 'image/jpeg';
            const isPNG = file.type === 'image/png';
            if (!isJPG && !isPNG) {
                this.$message.error('上传图片只能是 JPG 或 PNG格式!');
            }
            return (isJPG || isPNG);
        }

        //地图选点
        changeMap(e: any) {
            this.map.visible = false;
            this.mechanismData.location = e.position.join(",");
            this.mechanismData.postalAddress = e.address;
        }

        download() {
            window.open(baseUrl + `/file/download-empower?legal=${this.mechanismData.userName}&orgName=${this.mechanismData.name}&agent=${this.mechanismData.clientName}&idCard=${this.mechanismData.idCard}`, '_blank');
        }

        //退出
        logout() {
            this.$router.replace("/login");
        }
    }
